import { useMemo } from 'react';
import { Stack, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ProductType } from 'services/api/entities/stripe/product';
import { StyledTitle, StyledDescription } from './styled';

type PriceHeaderProps = {
  title: string;
  productType: ProductType;
};

const PriceBoxHeader = ({ title, productType }: PriceHeaderProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('desktop'));

  const description = useMemo(() => {
    const descriptionType = isMobile
      ? 'planShortDescription'
      : 'planDescription';

    return productType
      ? t(`subscription:${descriptionType}:${productType}`)
      : '';
  }, [t, isMobile, productType]);

  return (
    <Stack>
      <StyledTitle>{title}</StyledTitle>
      <StyledDescription>{description}</StyledDescription>
    </Stack>
  );
};

export default PriceBoxHeader;
